import React, { useEffect, useState } from "react";
import "../../style/Style.css";
import {
  ProductCardFlexible,
  SearchInput,
  Modal
} from "@sainsburys-tech/fable";
import { GridWrapper } from "@sainsburys-tech/grid";
import Headerfile from "../common/Headerfile";
import Footerfile from "../common/Footerfile";
import TemplatePopup from "../templates/TemplatePopup";
import { useGetPostsQuery } from "../../api/apiConfig";
import Styles from "./Templatespreview.module.css";
import { getLogisticsRole } from "../../utils/authToken";
import { USER_ROLE } from "../../constants/roles";
import Unauthorized from "../unauthorized/Unauthorized";

const Templates = () => {
  const [searchtext, setSearchtext] = useState("");
  const [errors, setErrors] = useState("");
  const { isLoading, isError, isSuccess, data, refetch } =
    useGetPostsQuery("templates");
  const [CardPrint, setCardPrint] = useState<any[]>([]);
  const [apiHeading, setApiHeading] = useState<string | null>(null);
  const [apiMessage, setApiMessage] = useState<string | null>(null);
  const [isResponseOpen, setResponseOpen] = useState(false);
    const [txtvalue, setTextvalue] = useState("");
    
  useEffect(() => {
    refetch();
  }, []);
  useEffect(() => {
    if (isSuccess === true) {
      setCardPrint(data?.Model);
    }
    if (isResponseOpen === false) {
      setSearchtext("");
      setTextvalue("");
    }
  }, [isSuccess, isResponseOpen]);

    useEffect(() => {
    let value: any;
      if (searchtext.length > 0) {
      value = data?.Model?.filter((item: any) =>
        searchtext
              ? item.Id.toString().toLowerCase().includes(searchtext) ||
              item.Identity.SBTemplateId.toString().toLowerCase().includes(searchtext) ||
              item.Identity.Name.toString().toLowerCase().includes(searchtext) ||
              item.Identity.Description.toString().toLowerCase().includes(searchtext)
              : item
      );
    }
    if (value && value.length === 0) {
      setApiMessage("Record not Found");
      setApiHeading("Error!!!");
      setResponseOpen(true);
    }
  }, [searchtext]);
  const textchange = (e: any) => {
    setTextvalue(e);
  };
  const handelchange = (e: any) => {
    if (e === "") {
      setErrors("Please enter search value");
      setSearchtext("");
      setTextvalue("");
    } else {
      setErrors("");
        setSearchtext(e.toLowerCase());
    }
  };
  const [visibility, setVisibility] = useState<boolean>(false);
  const [tempid, setTempid] = useState<string>("");
  const PoupPreview = (id: string) => {
    setTempid(id);
  };
  const popupCloseHandler = (): void => {
    setVisibility(false);
  };

  const loggedUserRole = getLogisticsRole();

  const isDisabled =
    loggedUserRole?.includes(USER_ROLE.ADMIN) ||
    loggedUserRole?.includes(USER_ROLE.READ_WRITE) ||
    loggedUserRole?.includes(USER_ROLE.READ_ONLY)
      ? false
      : true;

  return (
    <>
      <Headerfile />
      {isDisabled ? (
        <Unauthorized />
      ) : (
        <>
          <div style={{ margin: "1% 3% 3% 2%" }} className="py-4">
            <div className="row">
              <div className={`col-md-4 ${Styles.searchBox}`}>
                <label>
                  <SearchInput
                    label="Search Template"
                    value={txtvalue}
                    onChange={(e) => textchange(e)}
                    onSubmit={(e) => handelchange(e)}
                    placeholder="Pick Label"
                  />
                  <div className={Styles.error}>{errors}</div>
                </label>
              </div>
              <div className="col-md-4"></div>
              <div className="col-md-4"></div>
            </div>
          </div>
          {isLoading && (
            <div className={Styles.loadingContainer}>
              <div className={Styles.loadingSpinner}></div>
              <div className={Styles.loadingText}>Loading...</div>
            </div>
          )}
          {isError && <span className="ml-5">Something went wrong..</span>}
          <div className={Styles.card} style={{ padding: "55px" }}>
            <GridWrapper>
              <div className={Styles.MobileTemp}>
                                  { 
                     
                                      data?.Model?.filter((item) =>
                  searchtext
                                              ? item.Id.toString().toLowerCase().includes(searchtext) ||
                                              item.Identity.SBTemplateId.toString().toLowerCase().includes(searchtext) ||
                                              item.Identity.Name.toString().toLowerCase().includes(searchtext) ||
                                              item.Identity.Description.toString().toLowerCase().includes(searchtext)
                    : item
                ).map((value: any) => (
                  <ProductCardFlexible key={value.Id}>
                    <ProductCardFlexible.Image
                      onDoubleClick={() => PoupPreview(value.Id)}
                    >
                      <div
                        className="ds-max-w-full"
                        data-testid={"TemplateDetailDiv"}
                      >
                        <img
                          alt={value.Configuration?.Image}
                          style={{
                            border: "1px solid #0084F0",
                            padding: "5%",
                              maxWidth: "var(--template-img-max-width)"
                          }}
                          src={`data:image/jpeg;base64,${value.Configuration?.Image}`}
                          className={Styles.cardimg}
                        />
                      </div>
                    </ProductCardFlexible.Image>
                    <b className={Styles.wordWrap}>
                      Template ID: {value.Identity.SBTemplateId}
                    </b>
                    <b className={Styles.wordWrap}>
                      Name: {value.Identity.Name}
                    </b>
                    <b className={Styles.wordWrap}>
                      Description: {value.Identity.Description}
                    </b>
                    <ProductCardFlexible.Body>
                      <ProductCardFlexible.Body.Section></ProductCardFlexible.Body.Section>
                      <ProductCardFlexible.Body.Section></ProductCardFlexible.Body.Section>
                    </ProductCardFlexible.Body>
                    <ProductCardFlexible.Footer></ProductCardFlexible.Footer>
                  </ProductCardFlexible>
                ))}
              </div>
            </GridWrapper>
          </div>
          <TemplatePopup
            onClose={popupCloseHandler}
            show={visibility}
            title="Hello"
            tempid={tempid}
            CardPrint={CardPrint}
            children=""
          />
          <Modal
            isOpen={isResponseOpen}
            onClose={() => setResponseOpen(false)}
            layout="default"
            header={{
              isDismissible: true
            }}
          >
            <div className="text-center">
              <h3 className="text-center fw-500">{apiHeading}</h3>
              <h5 className="fw-400">{apiMessage}</h5>
            </div>
          </Modal>
        </>
      )}

      <Footerfile />
    </>
  );
};

export default Templates;
